import { CRUDFactory } from '../CRUDFactory';

export default CRUDFactory('/timezones');
